import React from "react";
import { formatINR } from "@/lib/format";
import { brand } from "@/config/brand";

export function FreeShippingBar({ subtotal }) {
  const threshold = brand.freeShippingThreshold;
  const remaining = Math.max(0, threshold - subtotal);
  const progress = Math.min(100, (subtotal / threshold) * 100);
  return (
    <div className="border-b border-border bg-cream px-6 py-4" data-testid="cart-free-shipping-bar">
      <p className="text-center text-xs text-ink">
        {remaining > 0 ? (
          <>
            You're <span className="font-semibold text-gold">{formatINR(remaining)}</span> away from{" "}
            <span className="uppercase tracking-wider">Free Shipping</span>
          </>
        ) : (
          <span className="uppercase tracking-wider text-gold">You've unlocked Free Shipping ✦</span>
        )}
      </p>
      <div className="mt-2.5 h-1.5 w-full overflow-hidden rounded-full bg-border">
        <div className="h-full rounded-full bg-gold transition-[width] duration-500" style={{ width: `${progress}%` }} />
      </div>
    </div>
  );
}
